


const consola = require('consola'); consola.level = process.env.CONSOLA_LEVEL;
import { mapGetters, mapMutations, mapActions } from 'vuex'
import domel from '~/components/domel'

import svgSymbol from '~/components/svg-symbol'
import ScrollObserver from '~/components/scroll-observer-raf'
import CourseDateUtils from '~/mixins/course-date-utils'
import LazyHydrate from 'vue-lazy-hydration';

import { putManualListFirst, sortCourses } from '~/src/sort-courses';

const endsWith = require('lodash.endswith')


export default {

	mixins: [CourseDateUtils],

	props: {
		block: { type: Object, required: true },
		courses: { type: Array, required: true },
		extra_data: { type: Array, required: true },
	},

	components:
	{
		LazyHydrate,
		// 'rest-img': RestImgDummy,// RestImg,
		// 'rest-prop': RestPropDummy, // RestProp,
		// 'rest-rich-text': RestRichTextDummy,// RestRichText,
		// 'rest-model': RestModelDummy,// RestModel,
		// 'rest-prop-link': RestPropLinkDummy, // 'rest-link': RestPropLink,
		// 'rest-link': RestPropLinkDummy, // 'rest-link': RestPropLink,
		// 'rest-string': RestStringDummy, // RestString,
		// 'rest-string-link': RestStringLinkDummy,// RestStringLink,
		// 'rest-date': RestDateDummy, // RestDate,
		// 'rest-date-add': domel,// RestDateAdd,
		// 'rest-reorder-list': RestReorderListDummy,//RestReorderList,
		// 'cms-edit': CmsEditDummy,
		// 'rest-list-item-add': domel,// RestListItemAdd,
		// 'rest-item-add': domel,// RestItemAdd,
		// 'rest-item-removable': domel,// RestItemRemovable,
		// 'tag-input': domel,// TagInput,

		svgSymbol,
		ScrollObserver,
	},

	data()
	{
		return {
			// blocks: [{}, {}, {}, {}, {}, {}, {}, {}, {}, ],

			// courseData: null,
			// currentSectionKey: 'key-benefits',

			courseCategories: [],
			selectedCatId: -1,

			_courses: [
			],

			isEditingPage: false,

		};
	},

	computed:
	{
		// ...mapGetters(['commonWords', 'getString', 'lang', 'langShort', 'allLanguages', 'isTablet', 'isLargerThanTabletLandscape']),
		...mapGetters([/*'isEditingPage',*/ 'getString', 'lang', 'langShort', 'allLanguages', 'adminPanelRef', 'windowWidth', 'isMobile', 'isTablet', 'isTabletOrBigger', 'isLargerThanTabletLandscape', 'isLaptop', 'isLaptopOrBigger', 'isDesktop', 'windowWidth', 'scrollTop']),

		filteredCourses()
		{
			let list = this._courses && this._courses.filter(
					x => this.selectedCatId == -1 ||
					x.category_list.filter(c => c.id==this.selectedCatId).length > 0
				)
				|| [];

			consola.debug('filteredCourses: ', list)
			return list;
		}
	},

	watch:
	{
		courses(newVal, oldVal)
		{
			const self = this;
			setTimeout( () =>
			{
				self.prepareCourseLists();
			}, 0 )
		},

		extra_data(newVal, oldVal)
		{
			const self = this;
			setTimeout( () =>
			{
				self.prepareCourseLists();
			}, 0 )
		},
	},

	// mounted()
	// beforeMount()
	created()
	{
		this.prepareCourseLists();
		const last = this.$route.path.split('/').filter(x => !!x).pop();
		this.isEditingPage = (last==='edit');
	},

	// mounted()
	// {
	// 	console.log('course list: ', this.courses.filter(x => !!x.is_published));
	// 	console.log('inactive course list: ', this.courses.filter(x => !x.is_published));
	// },

	methods:
	{
		modify(object, prop, value)
		{
			object[prop] = value;
			this.$eventBus.$emit('modify:model', { obj: object,  field: prop });
		},

		isFree(course)
		{
			return !course.tuition_json || !(course.tuition_json.length > 0) || !Number.isFinite(parseFloat(course.tuition_json[0].cost)) ;
		},

		prepareCourseLists()
		{
			// keep only courses that are marked as published (active)
			const publishedCourses = this.courses.filter(x => !!x.is_published);
			// sort courses based on their dates (if any). does not remove any course.
			let sortedCourses = sortCourses(publishedCourses);
			// put courses that have been sorted by the admin first
			this._courses = putManualListFirst(sortedCourses, this.extra_data);
			// allocate the categories list
			this.courseCategories = [];
			// loop through the courses, gathering their categories in the courseCategories list
			publishedCourses.forEach(course =>
			{
				course.category_list.forEach( cat =>
				{
					let found = this.courseCategories.find(c => c.id == cat.id);
					if (!found)
						this.courseCategories.push(cat)
				})
			});

			// sort categories alphabetically
			this.courseCategories.sort(function(a, b)
			{
				if (a.key > b.key)	return -1;
				if (a.key < b.key)	return 1;
				return 0;
			});

			
			// consola.debug("_courses: ", this._courses)
			// consola.debug("_courses: ", this._courses.map(x => x.id))
			// consola.debug("courseCategories: ", this.courseCategories)
		},

		onChangeCategory(cat)
		{
			if (!cat)
				this.selectedCatId = -1;
			else
				this.selectedCatId = cat.id;

			consola.debug('onChangeCategory: ', cat)
		},

		// sortCourses()
		// {
		// 	consola.debug('sortCourses()')
		// 	this._courses = this.courses.sort((a, b) =>
		// 	{
		// 		const a_time = ( this.upcomingDate(a.dates) || new Date() ).getTime();
		// 		const b_time = ( this.upcomingDate(b.dates) || new Date() ).getTime();

		// 		if (a_time < b_time)	return -1;
		// 		if (a_time > b_time)	return 1;
		// 		return 0;
		// 	})
		// },
	}


}
